import {ViewBase} from "@/rawdogjs/src/core/viewBase";
import {IView} from "@/rawdogjs/src/interfaces/IView";
import {ScheduleDatePresenter} from "./scheduleDatePresenter";
import {BookingDayView} from "./bookingDayView";
import {Router} from "@/rawdogjs/src/router";
import {ParcelDependencyContainer} from "@/rawdogjs/src/core/ParcelDependencyContainer";

export class ScheduleDateView extends ViewBase implements IView {

    public _presenter: ScheduleDatePresenter;

    public showPreviousWeek(show) {
        const e = this.$element.querySelector("#previous-week");
        e.disabled = !show;
    }

    public showNextWeek(show) {
        const e = this.$element.querySelector("#next-week");
        e.disabled = !show;
    }

    public showWeekPagingControls(show: boolean) {
        const element = this.$element.querySelector("#week-paging-controls");
        element.style.display = show ? 'block' : 'none';
    }

    public highlightSelection(date: Date) {
        const elements = this.$element.querySelectorAll("button[data-date]");
        
        for (const e of elements) {
            e.classList.add('outline');
        }

        for (const e of elements) {

            const itemDate = new Date(e.dataset.date);
            
            if (date.getDate() == itemDate.getDate() &&
                date.getMonth() == itemDate.getMonth() &&
                date.getFullYear() == itemDate.getFullYear()) {
                e.classList.remove('outline')
            }
            
        }
        
    }

    public setBookingDates(bookingDates: BookingDayView[]) {
        let html = ''

        for (const bookingDate of bookingDates) {
            let button = 
                `<button class='outline' data-date="${bookingDate.date}" 
                    style="padding:1rem 1rem;margin: 10px 10px 0px 0px;width:100%;text-align:left;">
                    ${bookingDate.dayOfWeek} ${bookingDate.dateString} 
                    <span class="bi bi-arrow-right-square"></span>
                </button>`;
            html += button;
        }

        // clear out 
        const element = this.$element.querySelector("#booking-dates");
        element.innerHTML = '';

        const item = document.createElement("div");
        item.innerHTML = html;

        element.append(item)
    }


    constructor(viewName: string, router: Router, dependencyContainer: ParcelDependencyContainer, presenter: ScheduleDatePresenter) {
        super(viewName, router, dependencyContainer);
        this._presenter = presenter;
    }

    public setPresenter(presenter: ScheduleDatePresenter) {
        this._presenter = presenter;
    }

    public render(): void {
    }

}